<mat-form-field appearance="outline" class="w-100">
    <mat-select [formControl]="control"
                panelClass="submittal-package-select-panel">
        @if (showEmptyOption) {
            <mat-option class="optionHeight" [value]="''"></mat-option>
        }
        @for (report of reportsList; track report.id ?? report.name) {
            <mat-option class="optionHeight" [value]="report.id" [disabled]="report.disabled"
                [class.option-header]="report.type === 'header'"
                [class.option-category]="report.type === 'category'"
                [class.option-option]="report.type === 'option'"
                [style.padding-left.px]="report.indentLevel ? report.indentLevel * 20 : 10">
                {{report.name}}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
